import React from 'react'
import {graphql} from 'gatsby'
import Layout from './../components/layout'
import WorkSubNav from './../components/work-sub-nav'
import WorkSubHeading from './../components/work-sub-heading'
import GalleryGrid from './../components/gallery-grid'
// import {PUBLIC_COLLECTIONS_IMAGES} from './../constants/public-collections-images'
import {PUBLIC_COLLECTIONS_IMAGES_STEPHEN_HAWKING} from './../constants/public-collections-images-stephen-hawking'
import WorkIntroText from './../components/work-intro-text'
import WorkFooterText from './../components/work-footer-text'
import ScrollToTop from './../components/scroll-to-top'

export default props => {
  const {data} = props
  const prismicData = {
    limitedEditionPrintsAreAvailable: data.prismicLimitedEditionPrintsPage.data.currently_available,
    introText: data.prismicPublicCollectionsPage.data.intro_text.html,
    footerText: data.prismicPublicCollectionsPage.data.footer_text.html,
    pageHeading: data.prismicPublicCollectionsPage.data.page_heading.text,
    images: data.prismicPublicCollectionsPage.data.images,
    showStephenHawkingImageAndInfo: data.prismicPublicCollectionsPage.data.show_stephen_hawking_image_and_info,
  }

  const PUBLIC_COLLECTIONS_IMAGES = prismicData.images.map(item => {
    return {
      title: item.image_title.text,
      fullUrl: item.image.url,
      thumbnailUrl: item.image.thumbnails.w400.url,
      orientation: item.image_orientation,
      supplementary_info: item.collection_name.text,
    }
  })

  return (
    <Layout pageName="public-collections" documentTitlePrefix={`${prismicData.pageHeading} | Work`}>
      <WorkSubNav
        currentPageName="public-collections"
        limitedEditionPrintsAreAvailable={prismicData.limitedEditionPrintsAreAvailable}
      />
      <WorkSubHeading headingText={prismicData.pageHeading} />
      <WorkIntroText html={prismicData.introText} />
      <GalleryGrid
        staticImagesFolderName="public-collections"
        imageData={PUBLIC_COLLECTIONS_IMAGES}
        classModifier="work"
        isPublicCollection={true}
        prompotedImageData={PUBLIC_COLLECTIONS_IMAGES_STEPHEN_HAWKING}
        showStephenHawkingImageAndInfo={prismicData.showStephenHawkingImageAndInfo}
      />
      <WorkFooterText html={prismicData.footerText} />
      <ScrollToTop />
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    prismicLimitedEditionPrintsPage {
      data {
        currently_available
      }
    }
    prismicPublicCollectionsPage {
      data {
        page_heading {
          text
        }
        footer_text {
          html
        }
        intro_text {
          html
        }
        images {
          image_title {
            text
          }
          collection_name {
            text
          }
          image {
            url(imgixParams: {q: 70, h: 1400, fit: "scale"})
            thumbnails {
              w400 {
                url(imgixParams: {q: 50})
              }
            }
          }
          image_orientation
        }
        show_stephen_hawking_image_and_info
      }
    }
  }
`
